/**
 * Response DTO for create delivery job for Ondway.
 */
export class CreateDeliveryJobForOndwayResponseDto {
  success: boolean;

  data: {
    job_id: number;
    job_cost: string;
    distance: string;
    waybill_url: string;
    driver_id: string;
    driver_name: string;
    pickup_route: string;
    drop_route: string;
  };
}
